import { TableSelectionColumnParams } from '@models/table.model.ts';

export interface PlaylistScreenOption {
  id: string;
  title: string;
  value: string;
}

export interface PlaylistScreenApiObject {
  _id: string;
  title: string;
  media: string | null;
  appPath?: string;
  mediaType?: string;
  sourceType?: string;
  animation?: string;
  orgId?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface PlaylistScreen {
  screen: PlaylistScreenApiObject;
  visibleDuration: number;
  animation: string;
}

export interface PlaylistModel {
  _id: string;
  name: string;
  orgId?: number;
  isActive: boolean;
  screensCount: number;
  screens: PlaylistScreen[];
  createdAt: string;
  updatedAt: string;
}

export enum PlaylistAnimationEnum {
  None = 'none',
  Fade = 'fade'
}

export interface PlaylistScreenFormItem {
  id: string;
  screen: PlaylistScreenOption | null;
  visibleDuration: string;
  animation: PlaylistAnimationEnum;
}

export interface PlaylistReqModel {
  name: string;
  screens: { screen: string; visibleDuration: number; animation: string }[];
}

export interface PlaylistColumnsParams extends TableSelectionColumnParams<PlaylistModel> {
  onEdit: (row: PlaylistModel) => void;
  onDelete: (row: PlaylistModel) => void;
}
